import React, { useEffect, useState } from 'react'
import { Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap'
import McDataServices from '../../services/McDataServices'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { RSelect } from '../../components/Component'

const AssignPackageModal = ({ isOpen, toggle, selectedUser }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [options, setOptions] = useState([])
  const [selectedPackage, setSelectedPackage] = useState(null)

  useEffect(() => {
    if (isOpen) {
      setSelectedPackage(null)
      fetchPackages()
    }
  }, [isOpen])

  const fetchPackages = async () => {
    setLoading(true)
    try {
      const response = await McDataServices.getPackages()
      const data = response.data || response
      const packagesList = data.content || data.packages || (Array.isArray(data) ? data : [])

      const newOptions = packagesList.map(pkg => ({
        value: pkg.name,
        label: pkg.name
      }))
      setOptions(newOptions)
    } catch (error) {
      console.error('Error fetching packages:', error)
      toast.error(t('admin.modal.fetchError', 'Failed to fetch packages.'))
    } finally {
      setLoading(false)
    }
  }

  const handleSave = async () => {
    if (!selectedPackage || !selectedUser) return
    setSaving(true)

    try {
      const payload = {
        userName: selectedUser.userName,
        packageName: selectedPackage.value
      }

      await McDataServices.assignPackage(payload)
      toast.success(t('admin.modal.assignSuccess', 'Package assigned successfully.'), {
        position: 'top-right',
        autoClose: 3000
      })
      toggle()
    } catch (error) {
      console.error('Assign package failed', error)
      toast.error(error?.response?.data?.detail || t('admin.modal.assignError', 'Failed to assign package.'), {
        position: 'top-right',
        autoClose: 3000
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
      <ModalHeader toggle={toggle} close={<button className="close" onClick={toggle}>×</button>}>
        {t('admin.table.assignPackage', 'Assign Package')}
      </ModalHeader>
      <ModalBody>
        <p>
          {t('admin.table.assignPackageDesc', 'Select a package to assign to:')}{' '}
          <strong>{selectedUser?.email || selectedUser?.userName}</strong>
        </p>
        <FormGroup>
          <Label>{t('admin.modal.packageName', 'Package Name')}</Label>
          <RSelect
            options={options}
            value={selectedPackage}
            onChange={(selected) => setSelectedPackage(selected)}
            placeholder={loading ? t('admin.loading', 'Loading...') : t('sp_select', 'Select...')}
            isDisabled={loading}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          {t('admin.modal.cancel', 'Cancel')}
        </Button>
        <Button color="primary" onClick={handleSave} disabled={!selectedPackage || saving}>
          {saving ? <Spinner size="sm" /> : t('admin.modal.saveChanges', 'Save Changes')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AssignPackageModal
